import { render, staticRenderFns } from "./shopCate.vue?vue&type=template&id=69f97ce6&scoped=true&"
import script from "./shopCate.vue?vue&type=script&lang=js&"
export * from "./shopCate.vue?vue&type=script&lang=js&"
import style0 from "./shopCate.vue?vue&type=style&index=0&id=69f97ce6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f97ce6",
  null
  
)

export default component.exports